module.exports = require("././angular-translate.js");


//////////////////
// WEBPACK FOOTER
// angular-translate (bower component)
// module id = 377
// module chunks = 1